import React, { type ComponentProps } from 'react';

import { useLocalizationContext } from '@order/Localization';

import { MenuPersonalizationRail } from '../../../../components/MenuPersonalizationRail';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuPersonalization = (props: MenuPersonalizationProps) => {
  const { product } = props;

  const { t } = useLocalizationContext();

  if (!product) {
    return null;
  }

  return (
    <MenuPersonalizationRail
      headerText={t('menu.personalization')}
      product={product}
    />
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuPersonalizationProps = Readonly<{
  product?: ComponentProps<typeof MenuPersonalizationRail>['product'];
  menuCollectionId: string | undefined;
}>;
